import SessionLayout from '../components/SessionLayout';
import DroLayout from '../components/DroLayout';

import multiguard from 'vue-router-multiguard';
import isAuthorized from '../../../router/hooks/isAuthorized';
import isMensurationForbidden from '../../../router/hooks/isMensurationForbidden';
import hasAccess from './hooks/hasAccess';

export default [
  {
    path: 'clients/:clientId/dro',
    name: 'dro',
    component: DroLayout,
    props: true,
    beforeEnter: multiguard([isAuthorized, hasAccess]),
  },
  {
    path: 'clients/:clientId/dro/session',
    name: 'dro-session',
    component: SessionLayout,
    props: true,
    beforeEnter: multiguard([isAuthorized, isMensurationForbidden, hasAccess]),
  },
];



// WEBPACK FOOTER //
// ./src/modules/dro/routes/index.js